export enum RoleName {
  Reader = 'reader',
  Editor = 'editor',
  Checker = 'checker',
  Approver = 'approver',
  Admin = 'administrator',
}
